import { render, staticRenderFns } from "./HseHandbookSigningVersionHeader.vue?vue&type=template&id=08d85ade&scoped=true&"
import script from "./HseHandbookSigningVersionHeader.vue?vue&type=script&lang=ts&"
export * from "./HseHandbookSigningVersionHeader.vue?vue&type=script&lang=ts&"
import style0 from "./HseHandbookSigningVersionHeader.vue?vue&type=style&index=0&id=08d85ade&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08d85ade",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
